export default "import './Editor';\r\n"